import { useEffect, useState } from 'react';
import { getProducts } from '../services/productCacheService';

export interface EsetBundleOption {
  /** cr001_products id sent as product_guid / product_id (the RS id — the backend
   *  resolves either an RS id or a Dataverse GUID). */
  guid: string;
  /** cr001_name, e.g. RSub.AV.ESET.1D1Y */
  sku: string;
}

// The ESET billing bundles in the cr001_products catalog: {R|B}Sub.AV.ESET[Adv]…
const ESET_BUNDLE_RE = /^[RB]Sub\.AV\.ESET/i;

/**
 * The ESET billing bundles from the shared product catalogue. Used by the
 * provisioning add-license form and the per-license edit (rebind) form.
 */
export function useEsetBundles(): EsetBundleOption[] {
  const [bundles, setBundles] = useState<EsetBundleOption[]>([]);
  useEffect(() => {
    let alive = true;
    getProducts()
      .then((r) => {
        if (!alive) return;
        setBundles(
          (r.items || [])
            .filter((p) => ESET_BUNDLE_RE.test(p.sku || ''))
            .map((p) => ({ guid: p.productId || '', sku: p.sku }))
            .filter((b) => b.guid),
        );
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return bundles;
}
